import React from "react";
import { Box as MUIBox, BoxProps as MUIBoxProps } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface CustomBoxProps extends Omit<MUIBoxProps, "sx"> {
    children?: React.ReactNode;
    className?: string;
    sx?: SxProps<Theme>;
}

const Box: React.FC<CustomBoxProps> = ({ children, className = "", sx, ...rest }) => {
    return (
        <MUIBox className={className} sx={sx} {...rest}>
            {children}
        </MUIBox>
    );
};

export default Box;
